import { mapState } from 'vuex';
import { notPrompt } from './request';
import verifyTab from './components/verifyTab.vue';
import editPassword from './components/editPassword.vue';
import editPasswordModal from './editPasswordModal.vue';
export default {
  components: {
    editPasswordModal,
    verifyTab,
    editPassword
  },
  props: {
    visibleModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visibleTipsModal: false,
      //密码安全度弹框
      isTip: false,
      //是否勾选7天之内不再提示
      visibleEditModal: false,
      //修改密码弹框
      visibleVerifyTab: true,
      //验证tab
      visibleEditPwd: false //修改密码
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo,
      resetPasswordModelVisible: state => state.user.resetPasswordModelVisible,
      timerInstance: state => state.message.timerInstance
    })
  },
  watch: {
    visibleTipsModal(val) {
      if (val) {
        this.timerInstance && clearTimeout(this.timerInstance);
      }
      this.$store.commit('user/SET_RESETPASSWORDMODELVISIBLE', val);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.visibleTipsModal = this.visibleModal;
    });
  },
  methods: {
    checkboxChange(e) {
      this.isTip = e.target.checked;
    },
    // 确认提示弹框
    async confirmTipsModal() {
      if (this.isTip) {
        // 7天之内不再提示
        await notPrompt();
        this.visibleTipsModal = false;
        this.$store.dispatch('message/loopPopMessageList', {});
        this.$store.commit('message/setMessageDetailVisible', false);
        // 打开修改密码弹框
        this.visibleEditModal = true;
      } else {
        this.visibleTipsModal = false;
        this.$store.dispatch('message/loopPopMessageList', {});
        this.$store.commit('message/setMessageDetailVisible', false);
        // 打开修改密码弹框
        this.visibleEditModal = true;
      }
      // 只有首次进入弹：更改store
      this.$store.commit('user/SET_COMPLEXITYPOPUP', 'false');
    },
    // 取消提示弹框
    async cancleTipsModal() {
      if (this.isTip) {
        // 7天之内不再提示
        await notPrompt();
      }
      this.visibleTipsModal = false;
      this.$store.dispatch('message/loopPopMessageList', {});
      this.$store.commit('message/setMessageDetailVisible', false);
      // 只有首次进入弹：更改store
      this.$store.commit('user/SET_COMPLEXITYPOPUP', 'false');
    }
  }
};